/** Aree applicative per utenti multi-ruolo (login e switch in-app). */
export const AREA_OPTIONS = [
  {
    role: 'ADMIN',
    label: 'Area Admin',
    shortLabel: 'Admin',
    path: '/admin/dashboard',
    matchPrefixes: ['/admin'],
    description: 'Gestione clinica, utenti e configurazioni'
  },
  {
    role: 'STRUTTURA_ADMIN',
    label: 'Area Struttura',
    shortLabel: 'Struttura',
    path: '/app/struttura',
    matchPrefixes: ['/app/struttura'],
    description: 'Dati e sedi delle tue strutture'
  },
  {
    role: 'MEDICO',
    label: 'Area Medico',
    shortLabel: 'Medico',
    path: '/app/medico/dashboard',
    matchPrefixes: ['/app/medico'],
    description: 'Appuntamenti, disponibilità, referti'
  },
  {
    role: 'PAZIENTE',
    label: 'Area Paziente',
    shortLabel: 'Paziente',
    path: '/app/paziente/dashboard',
    matchPrefixes: ['/app/paziente'],
    description: 'Prenotazioni, appuntamenti, referti'
  },
  {
    role: 'MERCHANT',
    label: 'Area Merchant',
    shortLabel: 'Merchant',
    path: '/merchant/dashboard',
    matchPrefixes: ['/merchant'],
    description: 'Pagamenti e prodotti'
  }
];

export function areasForRoles(roles) {
  const set = new Set((roles || []).map((r) => String(r).replace(/^ROLE_/, '')));
  return AREA_OPTIONS.filter((opt) => set.has(opt.role));
}

export function currentAreaFromPath(pathname) {
  const path = pathname || '';
  return (
    AREA_OPTIONS.find((opt) =>
      (opt.matchPrefixes || []).some(
        (prefix) => path === prefix || path.startsWith(`${prefix}/`)
      )
    ) || null
  );
}
